<template>
    <div class="Page">
        <Header Act="4"></Header>
        <div class="MaxWid">
            <!-- <div class="MarTop">
                <Banner></Banner>
            </div> -->
            <div class="QueryBtn MarTop">
                <div class="QueryBtnItem" :class="{Act:i ==1}" @click="ToggleNav(1)">机构查询</div>
                <div class="QueryBtnItem" :class="{Act:i ==2}" @click="ToggleNav(2)">个人查询</div>
            </div>
            <div class="QueryVal">
                <div class="QueryValDis">
                    <div class="QueryValItem">
                        <div class="QueryValItemTit">{{i ==2 ? '姓名' : '机构名称'}}</div>
                        <el-input class="WidMax" v-model="SetData.name" size="medium" placeholder="请输入"></el-input>
                    </div>
                    <div class="QueryValItem">
                        <!-- (目前是手机) -->
                        <div class="QueryValItemTit">注册号</div>
                        <el-input class="WidMax" v-model="SetData.code" size="medium" placeholder="请输入"></el-input>
                    </div>
                    <div class="QueryValItem" v-if="i ==2">
                       <div class="QueryValItemTit">类型</div>
                       <el-select class="WidMax" v-model="SetData.user_group_id" placeholder="请选择类型" clearable >
                           <el-option label="注册心理咨询师 (初级)" value="1" style="text-align: center;"></el-option>
                           <el-option label="注册心理咨询师 (中级)" value="2"></el-option>
                           <el-option label="注册心理咨询师 (高级)" value="3"></el-option>
                           <el-option label="注册心理督导师" value="4"></el-option>
                       </el-select>
                    </div>
                    <div class="QueryValItem" v-if="i ==1">
                       <div class="QueryValItemTit">机构类型</div>
                       <el-select class="WidMax" v-model="SetData.user_group_id" placeholder="请选择机构类型" clearable>
                           <el-option label="社会心理服务机构" value="5"></el-option>
                           <el-option label="见习实习机构" value="8"></el-option>
                           <el-option label="继续教育机构" value="7"></el-option>
                           <el-option label="学历教育机构" value="6"></el-option>
                           <!-- <el-option label="其他" value="其他"></el-option> -->
                       </el-select>
                    </div>
                    <div class="QueryValItem">
                        <div class="QueryValItemTit">省 市</div>
                        <el-cascader class="WidMax" filterable :props="{value:'id',label:'name',expandTrigger: 'hover' }" v-model="SetData.City" :options="CityData"></el-cascader>
                    </div>
                    
                    <div class="QueryValItem" v-if="i ==1">
                       <div class="QueryValItemTit">机构法人</div>
                       <el-input
                            class="WidMax"
                            v-model="SetData.legal_person"
                            size="medium"
                            placeholder="请输入机构法人"
                            clearable>
                       </el-input>
                    </div>
                    <div class="QueryValItem" v-if="i ==2">
                       <div class="QueryValItemTit">流派</div>
                       <!-- <el-input class="WidMax" v-model="SetData.major" size="medium" placeholder="请输入" clearable ></el-input> -->
                       <el-select class="WidMax" v-model="SetData.schools" placeholder="请选择流派" multiple collapse-tags clearable>
                           <el-option label="精神分析" value="精神分析"></el-option>
                           <el-option label="认知行为" value="认知行为"></el-option>
                           <el-option label="家庭治疗" value="家庭治疗"></el-option>
                           <el-option label="后现代" value="后现代"></el-option>
                           <el-option label="其他" value="其他"></el-option>
                       </el-select>
                    </div>
                    <div class="QueryValItem" v-if="i ==2">
                       <div class="QueryValItemTit">咨询方向</div>
                       <!-- <el-input class="WidMax" v-model="SetData.major" size="medium" placeholder="请输入" clearable ></el-input> -->
                       <el-select class="WidMax" v-model="SetData.be_good_at" placeholder="请选择咨询方向" multiple collapse-tags clearable>
                           <el-option label="情绪管理" value="情绪管理"></el-option>
                           <el-option label="婚姻与恋爱" value="婚姻与恋爱"></el-option>
                           <el-option label="家庭关系" value="家庭关系"></el-option>
                           <el-option label="心理健康" value="心理健康"></el-option>
                           <el-option label="儿童青少年心理" value="儿童青少年心理"></el-option>
                           <el-option label="老年心理" value="老年心理"></el-option>
                           <el-option label="职场心理" value="职场心理"></el-option>
                           <el-option label="人际关系" value="人际关系"></el-option>
                           <el-option label="性心理" value="性心理"></el-option>
                       </el-select>
                    </div>
                    
                    
                    
                    <div class="QueryValItem">
                        <div class="QueryValItemTit">其他</div>
                        <el-input class="WidMax" v-model="SetData.synopsis" size="medium" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="QueryValBtn" @click="SetQuy">查询</div>
            </div>
            <div class="QueryCont" v-if="Data">
                <div class="QueryContItem" v-for="item in Data" :key="item.id">
                    <div class="QueryContItemTit">
                        <div class="iconfont icon-shujidaoru"></div>
                        <div>{{item.name}}</div>
                        <div class="QueryContItemDis">
                            <div :class="[item.user_group_id==1?'ColorGreen':item.user_group_id==2?'ColorYellow':'ColorRed']">
                                {{item.user_group_id==1?'初级注册心理咨询师':item.user_group_id==2?'中级注册心理咨询师':item.user_group_id==3?'高级注册心理咨询师':item.user_group_id==4?'注册督导师':''}}</div>
                            <div>注册号:{{item.code}}</div>
                            <div>有效期:{{ item.passtime ? item.passtime.split(' ')[0].replace(/-/g, '/') : '' }}—{{formatDate(item.certificate_end_time)}}</div>
                            <!-- <div class="iconfont icon-message" @click="DigBlon=true"></div> -->
                        </div>
                    </div>
                    <div class="QueryContItemCont">
                        <!-- <div class="QueryContItemImg">
                            <img src="../../assets/img/test.png" alt="">
                        </div> -->
                        <div class="QueryContItemTxt">
                            <div class="State">
                                <div class="StateTit">注册状态</div>
                                <div class="StateTag" :class="[item.status=='hidden'?'BgBlue':(item.status=='publicity'||item.status=='normal')?'BgGreen':'BgRed']">
                                    <span v-if="item.status == 0">待提交</span>
                                    <span v-if="item.status == 1">评审待缴费</span>
                                    <span v-if="item.status == 2">推荐待确认</span>
                                    <span v-if="item.status == 3">推荐已驳回</span>
                                    <span v-if="item.status == 4">形式待审核</span>
                                    <span v-if="item.status == 5">形式已驳回</span>
                                    <span v-if="item.status == 6">专家待审核</span>
                                    <span v-if="item.status == 7">专家已驳回</span>
                                    <span v-if="item.status == 8">审核中</span>
                                    <span v-if="item.status == 9">审核中</span>
                                    <span v-if="item.status == 10">审核中</span>
                                    <span v-if="item.status == 11">公示中</span>
                                    <span v-if="item.status == 12">待缴注册费</span>
                                    <span v-if="item.status == 13">审核中</span>
                                    <span v-if="item.status == 14">审核中</span>
                                    <span v-if="item.status == 15">完成</span>
                                </div>
                            </div>
                            <!-- 个人查询：is_public_synopsis==1 才展示简介；为2/空则不展示 -->
                            <div v-if="i === 1 || item.is_public_synopsis == 1">{{item.synopsis}}</div>
                        </div>
                    </div>
                </div>
                <div class="PageDis">
                    <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"  @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page" :hide-on-single-page="true"></el-pagination>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="DigBlon" width="30%" :before-close="DigClose" :show-close="false">
            <span>{{text}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="DigClose">关闭</el-button>
                <el-button type="primary" @click="confirm" v-if="SucBtn">{{SucBtn}}</el-button>
            </span>
        </el-dialog>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    import Banner from '@/components/banner/Banner';
    export default {
        components: {Header,Footer,Banner},
        data() {
            return {
                i:1,
                Data:"",
                total:0,
                page:1,
                SizePage:10,
                DigBlon:false,
                SetData:{
                    City:[],
                },
                CityData: [],
                text:"您好，是否发送您的联系方式给此专业人员？",
                SucBtn:"确定",
            }
        },
        mounted() {
            this.GetCommType();
        },
        methods: {
            GetData(){
                var Url="api/join_in/companySearch";
                var Quy = JSON.parse(JSON.stringify(this.SetData));
                Quy.page=this.page;
                Quy.limit=this.SizePage;
                // Quy.register_major_company_id=1;
                if(this.i == 2){
                    Url="api/join_in/peopleSearch";
                    // Quy.register_professional_id=1;
                }
                if(Quy.City.length>0){
                    Quy.province = Quy.City[0];
                    Quy.city = Quy.City[1];
                }
                this.$post(Url,Quy,{
                    page:this.page,
                    limit:this.SizePage,
                }).then(res => {
                    this.Data = [];
                    if(res.data.code == 1){
                        this.total = res.data.data.total;
                        this.Data = res.data.data.data;

                        if (this.Data.length == 0){
                            this.$message({
                                message:'查询无结果',
                                type: 'warning'
                            });
                        }
                    }
                })
            },
            SetQuy(){
                this.page = 1;
                this.GetData();
            },
            confirm(i){
                this.text = "您的联系方式已发送，请耐心等待专业人员与您联系";
                this.SucBtn = "";
            },
            DigClose(){
                this.text ="您好，是否发送您的联系方式给此专业人员？",
                this.SucBtn = "确定";
                this.DigBlon = false;
            },
            ToggleNav(i){
                this.i = i;
                this.SetData={
                    City:[],
                };
            },
            GetCommType(){
                this.$get("api/common/areaList")
                .then(res => {
                     if(res.data.code == 1){
                         this.CityData =res.data.data;
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })
            },
            SizeChange(val) {
                this.SizePage = val;
                this.GetData();
            },
            PageChange(val) {
                this.page = val;
                this.GetData();
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
            formatDate(timestamp) {
                if (!timestamp) return '';
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}/${month}/${day}`;
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }

    .BgColorBlue {
        background-color: #037dbe;
    }

    .BgColorYellow {
        background-color: #ed8404;
    }

    .BgColorGreen {
        background-color: #82ae1d;
    }
    .ColorGreen{
        color:#d5ff74;
    }
    .ColorYellow{
        color:#ffcb0b;
    }
    .ColorRed{
        color:#e51414;
    }
    .MarTop {
        margin-top: 20px;
    }

    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .QueryBtn{
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .QueryBtnItem{
        flex: 1;
        padding: 10px 0;
        text-align: center;
        border-bottom: 1px solid #ccc;
        font-weight: 400;
        font-size: 20px;
        color: #666666;
        cursor: pointer;
    }
    .QueryBtnItem:hover,
    .QueryBtnItem.Act{
        background: #0385EB;
        color: #fff;
    }
    .QueryVal{
        padding: 20px 0;
    }
    .QueryValDis{
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
    }
    .QueryValItem{
        margin-top: 10px;
        display: flex;
        align-items: center;
    }
    .QueryValItem .QueryValItemTit{
        font-size: 16px;
        width: 85px;
        text-align: right;
        margin-right: 20px;
        color: #666;
    }
    .QueryValItem .WidMax{
        width: 200px;
    }
    .QueryValBtn{
        margin:  30px auto ;
        width: 120px;
        text-align: center;
        padding: 7px 15px;
        color: #fff;
        font-size: 18px;
        background: #0286eb;
        border-radius: 20px;
        cursor: pointer;
    }
    .QueryContItemTit{
        padding: 10px;
        color: #fff;
        font-size: 16px;
        background: #0286eb;
        display: flex;
        align-items: center;
    }
    .QueryContItemTit div{
        margin-right: 20px;
    }
    .QueryContItemTit div:last-child{
        margin-right: 0;
    }
    .QueryContItemDis{
        display: flex;
        align-items: center;
    }
    .QueryContItemDis .icon-message{
        font-weight: 100;
        cursor: pointer;
    }
    .QueryContItemCont{
        padding: 20px 0;
        display: flex;
    }
    .QueryContItemImg{
        width: 120px;
        margin-right: 20px;
    }
    .State{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }
    .StateTit{
        font-weight: 400;
        font-size: 16px;
        color: #999;
    }
    .StateTag{
        margin-left: 10px;
        padding: 3px 15px;
    }
    .StateTag.BgBlue{
        background: #e8f3fc;
        border: 1px solid #9cc1f1;
        color: #3a83e4;
    }
    .StateTag.BgGreen{
        background: #E4F9EF;
        border: 1px solid #A4EACA;
        color: #49D696;
    }
    .StateTag.BgRed{
        background: #fac2c2;
        border: 1px solid #d51938;
        color: #d51938;
    }
    .QueryContItemTxt{
        flex: 1;
        line-height: 30px;
        font-size: 16px;
        color: #737373;
    }
    .PageDis{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }
    @media only screen and (max-width: 536px) {
        .QueryVal{
            padding: 0;
        }
        .QueryValItem {
            flex: 1 1 100%;
            margin-bottom: 10px;
        }
        .QueryValItem:last-child{
            margin-bottom: 0;
        }
        .QueryValItem .QueryValItemTit{
            width: 80px;
            text-align: right;
        }
        .QueryContItemTit{
            justify-content: space-between;
        }
        .QueryContItemTit div{
            margin: 0;
        }
        .QueryContItemDis{
            display: block;
        }
    }
</style>